import GoBackArrow from 'common/components/general/GoBackArrow';
import paths from 'routing/routes/_paths';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';

import ShadowBox from 'common/components/general/ShadowBox';
import { useForm } from 'utils/hooks';
import { useEffect, useState } from 'react';
import { useActions } from 'utils/hooks';
import useRouter from 'use-react-router';
import { replaceImageUrlsWithIds, getFileIdsFromHtml } from 'common/utils/post-images';

import Body from './Body';
import config from './config';

import * as postActions from 'store/beacon/posts/actions';
import * as listActions from 'store/lists/actions';
import PageLoader from 'common/components/general/PageLoader';

const PostForm = () => {
  const [getBeaconPost, createBeaconPost, editBeaconPost, fetchListOptions] = useActions([
    postActions.getBeaconPost,
    postActions.createBeaconPost,
    postActions.editBeaconPost,
    listActions.fetchListOptions
  ]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { formState, collectValues, loadValues, resetForm } = useForm(config);
  const { history, match } = useRouter();

  const onSave = async () => {
    const values = collectValues();

    if (!values) return;

    try {
      setIsSubmitting(true);

      const { pages, attachments, content, ...rest } = values;
      const contentWithFileIds = replaceImageUrlsWithIds(content, attachments);

      const params = {
        ...rest,
        pages: pages.filter(({ url }) => url)?.map(({ url }) => url) || [],
        content: contentWithFileIds || '',
        attachment_ids: getFileIdsFromHtml(contentWithFileIds, true).map(id => id)
      };

      if (match.params.id) {
        await editBeaconPost({ ...params, id: match.params.id }).unwrap();
      } else {
        await createBeaconPost(params).unwrap();
      }

      history.push(`${paths.beacon}/posts`);
      setIsSubmitting(false);
    } catch (error) {
      console.error(error);
      setIsSubmitting(false);
    }
  };

  const initPost = async () => {
    try {
      setIsLoading(true);

      const data = await getBeaconPost({ id: match.params.id }).unwrap();
      const { pages, ...rest } = data;

      loadValues({
        ...rest,
        pages: pages?.length ? pages?.map(({ page_url }) => ({ url: page_url })) : [{}]
      });

      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (match.params.id) initPost();
    else resetForm();

    fetchListOptions('beacon-pages-suggestions');
  }, [match.params.id]);

  if (isLoading) return <PageLoader isLoading={isLoading} />;

  return (
    <div>
      <div className="d-flex align-items-center flex-nowrap">
        <GoBackArrow to={`${paths.beacon}/posts`} />
        <span className="fs-16 ps-2">{match.params.id ? 'Edit post' : 'Create a new post'}</span>
        <Link to={`${paths.beacon}/posts`} className="px-0 py-1 me-4 ms-auto btn btn-cancel">
          CANCEL
        </Link>
        <Button color="primary" className="px-4" onClick={onSave} disabled={isSubmitting}>
          SAVE
        </Button>
      </div>
      <ShadowBox className="px-3 py-2 mt-3" flat>
        <Body formState={formState} />
      </ShadowBox>
    </div>
  );
};

export default PostForm;
